import { useEffect, useState } from 'react'

export const useShowNotification = (): [boolean, () => void] => {
    const itemName = 'news_notification_timestamp'

    const [isNotificationVisible, setIsNotificationVisible] = useState(() => {
        let notificationItem = localStorage.getItem(itemName)
        if (!notificationItem) {
            localStorage.setItem(itemName, Date.now().toString())
            notificationItem = Date.now().toString()
        }

        const notificationTimestamp = +notificationItem
        const currentShowingTime = Date.now() - notificationTimestamp
        const isNotificationVisible = currentShowingTime < 30000

        return isNotificationVisible
    })

    useEffect(() => {
        const notificationItem = localStorage.getItem(itemName)

        if (notificationItem) {
            const notificationTimestamp = +notificationItem
            const currentShowingTime = Date.now() - notificationTimestamp

            const timerId = setTimeout(() => setIsNotificationVisible(false), 30000 - currentShowingTime)

            return () => clearTimeout(timerId)
        }

        return
    })

    const hideNotification = () => {
        localStorage.setItem(itemName, (Date.now() - 30000).toString())
        setIsNotificationVisible(false)
    }

    return [isNotificationVisible, hideNotification]
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/hooks/useShowNotification.tsx